<template>
  <div
    class="diy-richText"
    :style="'overflow:hidden;padding:'+itemStyle.paddingTop+'px '+itemStyle.paddingLeft+'px; background:'+itemStyle.background"
  >
    <div v-html="params.content" class="html"></div>
  </div>
</template>

<script>
export default {
  components: {
    // temp
  },
  props: ["itemIndex", "itemStyle", "params"],
  created() {
  },
  activated() {},
  methods: {}
};
</script>

<style lang="less" scoped>
@import url("../../style/skin.less");
.diy-richText {
  font-size: 14px;
}
</style>
<style>
.html {
  width: 100%;
  float:left;
}
.html p {
  font-size: 12px;
  overflow: hidden;
}
.html img {
  width: 100%;
  height: 100%;
  float: left;
}
</style>